import { NotificationsNoneOutlined } from "@mui/icons-material";
import { BellRenderer, BodyRenderer, SubjectBodyRendererProps, SubjectRenderer } from "@novu/react";

import Avatar from "fond/widgets/Avatar";

import {
  getLegacyActorName,
  getLegacyCommentBody,
  getLegacyCommentSubject,
  hasNotificationActor,
  isLegacyCommentNotification,
  isLegacyRequestLicenseNotification,
} from "./helper";

import { CountBadge, NotificationBody, NotificationSubject } from "./renderFunctions.styles";

export const renderBell: BellRenderer = (unreadCount) => {
  return (
    <CountBadge badgeContent={unreadCount.total}>
      <NotificationsNoneOutlined sx={{ color: "white", fontSize: "1.8rem" }} />
    </CountBadge>
  );
};

export const renderBody: BodyRenderer = (notification) => {
  if (isLegacyCommentNotification(notification) || isLegacyRequestLicenseNotification(notification)) {
    const body = getLegacyCommentBody(notification);
    return <NotificationBody className="legacy">{body}</NotificationBody>;
  }
  return <NotificationBody>{notification.body}</NotificationBody>;
};

export const renderSubject: SubjectRenderer = (notification) => {
  if (isLegacyCommentNotification(notification) || isLegacyRequestLicenseNotification(notification)) {
    const content = getLegacyCommentSubject(notification);
    return <NotificationSubject className="legacy">{content}</NotificationSubject>;
  }
  return <NotificationSubject>{notification.subject}</NotificationSubject>;
};

export const renderAvatar: SubjectBodyRendererProps["renderAvatar"] = (notification) => {
  let name;

  if (hasNotificationActor(notification)) {
    name = `${notification.data.UserFirstName} ${notification.data.UserLastName}`;
  }
  if (!name) {
    name = getLegacyActorName(notification) ?? undefined;
  }
  return <Avatar name={name} variant="rounded" className="settings-button-account-avatar" />;
};
